import Utils from '@/common/utils/utils';
import APIAmplify from '@aws-amplify/api';

import Constant from '@/common/constant/Constant';
import NotificationEventType from '@/common/constant/NotificationEventType';
import localStorageUtil from "@/common/utils/localStorageUtil";
import { onGetNotificationByFilter, onTicketCreated } from '@/graphql/subscriptions';
import { signOut } from '@/service/authenService';
import { notificationListAtom, notificationUnReadListAtom } from '@/state/atom/notificationAtom';
import { cloneDeep } from 'lodash';
import { getRecoil } from 'recoil-nexus';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import { openTelephoneTicketPanel } from '@/component/telephoneAgent/handler/TelephoneTicketPanelHandler';
import { activeCallAtom, outboundCallAtom } from '@/state/atom/voiceCallAtom';

// list all subscription for notification
let subscriptionNotificationList = [];

// ticket created subscription instance
let ticketCreatedSubscription = null;

const getMsgWhenCreateEmailTicket = (sourceInfo) => {
    let msg = '';

    switch (sourceInfo.mailCode) {
        case Constant.NOTI_MAIL_CODE.NOTI_MAIL_RECEIVE_EMAIL_FROM_PERSIONAL_AND_CREATE_EMAIL_TICKET:
            msg = `${sourceInfo.sendingUserName || sourceInfo.creatorName}さんから新規メールチケット「${sourceInfo.ticketOutline}」がありました。(${sourceInfo.projectName})`;
            break;
        case Constant.NOTI_MAIL_CODE.NOTI_MAIL_RECEIVE_EMAIL_FROM_PROJECT_AND_CREATE_EMAIL_TICKET:
            msg = `${sourceInfo.sendingPrjName || sourceInfo.creatorName}から新規メールチケット「${sourceInfo.ticketOutline}」がありました。(${sourceInfo.projectName})`;
            break;
    
        default:
            msg = `${sourceInfo.creatorName}さんから新規メールチケット「${sourceInfo.ticketOutline}」がありました。(${sourceInfo.projectName})`;
            break;
    }
    
    return msg;
}

/**
 * Get notification msg
 * @param {*} notification
 * @returns notificationMsg
 */
export const getNotificationMsg = notification => {
    let sourceInfo = JSON.parse(notification.sourceInfo);
    let msg = '';
    let eventType = notification.eventType;
    let updateUserName;

    let defaultOutlineNoValue = `[${Constant.TICKET_NO_TITLE}]`;
    if (notification.objectType === Constant.NOTIFICATION_OBJECT_TYPE.EMAIL) {
        defaultOutlineNoValue = `[${Constant.EMAIL_TICKET_NO_TITLE}]`;
    }
    sourceInfo.ticketOutline = Utils.isEmptyString(sourceInfo?.ticketOutline) ? defaultOutlineNoValue : sourceInfo?.ticketOutline;
    switch (eventType) {
        // ticket
        // 1. ＜ユーザー＞さんから新規問い合わせ「＜チケット概要＞」がありました（＜プロジェクト＞））。
        case NotificationEventType.TICKET_NEW:
            let creatorName = sourceInfo.creatorName ? sourceInfo.creatorName : '';
            msg =
                creatorName !== 'anonymous'
                    ? `${creatorName}さんから新規問い合わせ「${sourceInfo.ticketOutline}」がありました。（${sourceInfo.projectOriginName}）`
                    : `未登録カスタマーから新規問い合わせ「${sourceInfo.ticketOutline}」がありました。`;
            if (sourceInfo.anonymousType === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT) msg = `ライブチャットの要求があります。`;
            switch (notification.objectType) {
                // notice
                case Constant.NOTIFICATION_OBJECT_TYPE.NOTICE:
                    msg = `${sourceInfo.projectOriginName}から新規お知らせ「${sourceInfo.ticketOutline}」がありました。`;
                    break;
                // knowledge
                case Constant.NOTIFICATION_OBJECT_TYPE.KNOWLEDGE:
                    msg = `${sourceInfo.projectOriginName}から新規ナレッジ「${sourceInfo.ticketOutline}」がありました。`;
                    break;
                case Constant.NOTIFICATION_OBJECT_TYPE.REQUEST_EXTERNAL_DESK:
                    msg = `${sourceInfo.projectOriginName} から新規取引申請「${sourceInfo.ticketOutline}」がありました。`;
                    break;
                case Constant.NOTIFICATION_OBJECT_TYPE.DELEGATE:
                    msg = `${creatorName}さんから新規代理発行問い合わせ「${sourceInfo.ticketOutline}」がありました。（${sourceInfo.projectTargetName}）`;
                    break;
                case Constant.NOTIFICATION_OBJECT_TYPE.REQUEST_EXTERNAL_CUSTOMER:
                    msg = `${sourceInfo.projectOriginName} から新規取引申請「${sourceInfo.ticketOutline}」がありました。`;
                    break;
                case Constant.NOTIFICATION_OBJECT_TYPE.QA:
                    if (sourceInfo.isNotProxiedUser) {
                        msg = `${creatorName}から新規問い合わせ「${sourceInfo.ticketOutline}」がありました。`;
                    }
                    break;
                case Constant.NOTIFICATION_OBJECT_TYPE.TASK:
                    msg = `${sourceInfo.creatorName}さんから新規タスクチケット「${sourceInfo.ticketOutline}」がありました。(${sourceInfo.projectName})`;
                    break;
                case Constant.NOTIFICATION_OBJECT_TYPE.EMAIL:
                    msg = getMsgWhenCreateEmailTicket(sourceInfo)
                    break;
                case Constant.NOTIFICATION_OBJECT_TYPE.TELEPHONE:
                    // Use notificationContent from sourceInfo if available, otherwise build from sourceInfo
                    msg = sourceInfo?.notificationContent;
                    break;
                default:
                    break;
            }
            break;
        case NotificationEventType.TICKET_UPDATE:
            updateUserName = sourceInfo.creatorName ? sourceInfo.creatorName : '';
            let updateAction = '';
            if (sourceInfo.approveFlag === Constant.APPROVE_FLAG.APPROVE) {
                updateAction = '承認';
            }
            if (sourceInfo.approveFlag === Constant.APPROVE_FLAG.REJECTED) {
                updateAction = '却下';
            }

            switch (notification.objectType) {
                case Constant.NOTIFICATION_OBJECT_TYPE.REQUEST_EXTERNAL_CUSTOMER:
                case Constant.NOTIFICATION_OBJECT_TYPE.REQUEST_EXTERNAL_DESK:
                case Constant.NOTIFICATION_OBJECT_TYPE.INVITATION_GUEST_DESK_PROJECT:
                case Constant.NOTIFICATION_OBJECT_TYPE.INVITATION_GUEST_PROJECT:
                    msg = `${updateUserName}さんがチケット「${sourceInfo.ticketOutline}」を${updateAction}しました。(${sourceInfo.projectOriginName})`;
                    break;
                case Constant.NOTIFICATION_OBJECT_TYPE.TASK:
                    msg = `${updateUserName}さんがチケット「${sourceInfo.ticketOutline}」を更新しました。(${sourceInfo.projectOriginName})`;
                    break;
                case Constant.NOTIFICATION_OBJECT_TYPE.EMAIL:
                    msg = `${updateUserName}さんがメールチケット「${sourceInfo.ticketOutline}」を更新しました。(${sourceInfo.projectOriginName})`;;
                    break;
                case Constant.NOTIFICATION_OBJECT_TYPE.TELEPHONE:
                    msg = sourceInfo?.notificationContent;
                    break;
                default:
                    msg = `${updateUserName}さんがチケット「${sourceInfo.ticketOutline}」を更新しました。(${sourceInfo.projectOriginName})`;
                    break;
            }

            if (notification.objectType === Constant.NOTIFICATION_OBJECT_TYPE.QA && sourceInfo.approveFlag) {
                msg = `${updateUserName}さんがチケット「${sourceInfo.ticketOutline}」を${updateAction}しました。(${sourceInfo.projectOriginName})`;
            }

            break;
        case NotificationEventType.UPDATE_PIC:
            updateUserName = sourceInfo.creatorName ? sourceInfo.creatorName : '';
            msg = `あなたにチケット「${sourceInfo.ticketOutline}」が割り当てられました。(${sourceInfo.projectOriginName})`;
            if (notification.objectType === Constant.NOTIFICATION_OBJECT_TYPE.EMAIL) {
                msg = `あなたにメールチケット「${sourceInfo.ticketOutline}」が割り当てられました。(${sourceInfo.projectOriginName})`;
                break;
            }
            if (
                notification?.objectType === Constant.NOTIFICATION_OBJECT_TYPE.TELEPHONE &&
                sourceInfo?.telephoneType === TelephoneConstant.METADATA_TELEPHONE_TYPE.TRAINING
            ) {
                msg = `あなたにチケット「${sourceInfo.ticketOutline}」の評価担当が割り当てられました。（${sourceInfo.projectOriginName}）`;
                break;
            }
            if (
                notification?.objectType === Constant.NOTIFICATION_OBJECT_TYPE.TELEPHONE &&
                sourceInfo?.ticketCallType === TelephoneConstant.CALL_TYPE.VOICE_CALL
            ) {
                // defined on backend
                msg = sourceInfo?.notificationContent;
                break;
            }
            break;
        case NotificationEventType.TICKET_APPROVAL_REQUEST:
            msg = ``;
            break;
        case NotificationEventType.TICKET_DEADLINE_REACHED:
            msg = ``;
            break;
        case NotificationEventType.TICKET_APPROVAL_IN_WORKFLOW:
            msg = ``;
            break;
        case NotificationEventType.TICKET_REJECT_IN_WORKFLOW:
            msg = ``;
            break;

        // chat
        // 10. ＜ユーザー＞さんから「＜チケット概要＞」にメッセージがありました（＜プロジェクト＞））。
        case NotificationEventType.MESSAGE_NEW:
            const ticketType = sourceInfo.ticketType
            const chatSendBy = sourceInfo.chatSendBy
            if ([Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY].includes(ticketType)) {
                switch (chatSendBy) {
                    case Constant.EMAIL_SEND_BY_OPTION.CUSTOMER_IN_DESK:
                        msg = `${sourceInfo.creatorName}からメールチケット「${
                            sourceInfo.ticketOutline
                        }」にメッセージがありました。（${sourceInfo.affiliationProjectName ||
                            ''}）`;
                        break;
                    default:
                        msg = `${sourceInfo.creatorName}さんからメールチケット「${
                            sourceInfo.ticketOutline
                        }」にメッセージがありました。（${sourceInfo.affiliationProjectName ||
                            ''}）`;
                }
            } else {
                msg = `${sourceInfo.creatorName}さんから「${
                    sourceInfo.ticketOutline
                }」にメッセージがありました。
                （${
                    Utils.isEmptyString(sourceInfo.affiliationProjectName)
                        ? ''
                        : sourceInfo.affiliationProjectName
                }）`;
                if (notification.objectType === Constant.NOTIFICATION_OBJECT_TYPE.TELEPHONE) {
                    msg = sourceInfo?.notificationContent;
                }
            }
            break;
        case NotificationEventType.MESSAGE_MENTION_TO:
            msg = `${sourceInfo.creatorName}さんが「${
                sourceInfo.ticketOutline
            }」であなたにメンションしました。（${
                Utils.isEmptyString(sourceInfo.affiliationProjectName)
                    ? ''
                    : sourceInfo.affiliationProjectName
            }）`;
            if (notification.objectType === Constant.NOTIFICATION_OBJECT_TYPE.TELEPHONE) {
                    msg = sourceInfo?.notificationContent;
            }
            break;
        case NotificationEventType.MESSAGE_MENTION_ALL:
            msg = `${sourceInfo.creatorName}さんから「${
                sourceInfo.ticketOutline
            }」にメッセージがありました。（${
                Utils.isEmptyString(sourceInfo.affiliationProjectName)
                    ? ''
                    : sourceInfo.affiliationProjectName
            }）`;
            if (notification.objectType === Constant.NOTIFICATION_OBJECT_TYPE.TELEPHONE) {
                msg = sourceInfo?.notificationContent;
            }

            break;
        case NotificationEventType.MESSAGE_UPDATE:
            msg = ``;
            break;

        // 13. ＜ユーザー＞さんが「＜チケット概要＞」のスレッドでスタンプを送信しました（＜プロジェクト＞）。
        case NotificationEventType.MESSAGE_STAMP_NEW:
            msg = `＜ユーザー＞さんが「＜チケット概要＞」のスレッドでスタンプを送信しました。（＜プロジェクト＞）`;
            break;
        // 14. ＜コンテンツ＞　写真、動画、音楽、PDF、ファイル。
        // <ユーザー＞さんが「＜チケット概要＞」のスレッドで＜コンテンツ＞を投稿しました（＜プロジェクト＞)。
        case NotificationEventType.MESSAGE_ATTACHMENT_NEW:
            let fileName = !Utils.isEmptyString(sourceInfo.fileName)
                ? sourceInfo.fileName.toLowerCase()
                : 'undefine';
            msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketOutline}」のスレッドでファイルを投稿しました (${sourceInfo.affiliationProjectName})`;
            // images
            let isImageFile = /\.(jpe?g|tiff?|png|webp|bmp)$/i.test(fileName);
            if (isImageFile) {
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketOutline}」のスレッドで写真を投稿しました。(${sourceInfo.affiliationProjectName})`;
                break;
            }

            // gif
            let isGifFile = /\.(gif|GIF)$/i.test(fileName);
            if (isGifFile) {
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketOutline}」のスレッドで動画を投稿しました。(${sourceInfo.affiliationProjectName})`;
                break;
            }

            // music
            let isMusicFile = /\.(mp3|MP3|mpeg|MPEG|m3u|M3U)$/i.test(fileName);
            if (isMusicFile) {
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketOutline}」のスレッドで音楽を投稿しました。(${sourceInfo.affiliationProjectName})`;
                break;
            }

            // pdf
            let isPdfFile = /\.(pdf|PDF)$/i.test(fileName);
            if (isPdfFile) {
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketOutline}」のスレッドでPDFを投稿しました。(${sourceInfo.affiliationProjectName})`;
                break;
            }

            let isVideo= /\.(mp4|avi|mov|wmv|flv)$/i.test(fileName?.toLowerCase())
            if (isVideo) {
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketOutline}」のスレッドで動画を投稿しました。(${sourceInfo.affiliationProjectName})`;
                break;
            }

            msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketOutline}」のスレッドでファイルを投稿しました。(${sourceInfo.affiliationProjectName})`;
            break;
        // 12. あなたの「＜チケット概要＞」のメッセージに＜ユーザー＞さんがリアクションしました（＜プロジェクト＞）。
        case NotificationEventType.MESSAGE_REACTION:
            msg = `あなたの「＜チケット概要＞」のメッセージに＜ユーザー＞さんがリアクションしました。（＜プロジェクト＞）`;
            break;

        // user
        // 15. あなたにAdministrator権限が追加されました。
        case NotificationEventType.ADMIN_ON:
            msg = `あなたに組織マネージャ―権限が追加されました。`;
            break;
        // 16. あなたのAdministrator権限が削除されました。
        case NotificationEventType.ADMIN_OFF:
            msg = `あなたの組織マネージャ―権限が削除されました。`;
            break;
        // todo [Pending] 17. あなたはSolutionDesk契約のOwnerになりました。
        case NotificationEventType.OWNER_ON:
            msg = `あなたはSolutionDesk契約のOwnerになりました。`;
            break;
        // todo [Pending] 18. あなたはSolutionDesk契約のOwnerでなくなりました。
        case NotificationEventType.OWNER_OFF:
            msg = `あなたはSolutionDesk契約のOwnerでなくなりました。`;
            break;
        // 19. あなたのIDは＜以前のIDステータス＞から＜今のIDステータス＞に変更になりました。
        // General: ON/OF
        case NotificationEventType.USER_TYPE_CHANGE:
            msg = `あなたのIDは${sourceInfo.oldType}から${sourceInfo.newType}に変更になりました。`;
            break;

        // case NotificationEventType.GENERAL_OFF:
        //     msg = ``;
        //     break;

        // 22. あなたは＜プロジェクト＞のメンバーとして追加されました。
        case NotificationEventType.MEMBER_ON:
            msg = `あなたは${sourceInfo.projectName}のメンバーとして追加されました。`;
            break;
        // 23. あなたは＜プロジェクト＞のメンバーから削除されました。
        case NotificationEventType.MEMBER_OFF:
            msg = `あなたは${sourceInfo.projectName}のメンバーから削除されました。`;
            break;
        // 24. あなたは＜プロジェクト＞のプロジェクトマネージャーになりました。
        case NotificationEventType.PM_ON:
            msg = `あなたは${sourceInfo.projectName}のプロジェクトマネージャーになりました。`;
            break;
        // 25. あなたは＜プロジェクト＞のプロジェクトマネージャーでなくなりました。
        case NotificationEventType.PM_OFF:
            msg = `あなたは${sourceInfo.projectName}のプロジェクトマネージャーでなくなりました。`;
            break;
        case NotificationEventType.EXCEED_MAX_TICKET:
            msg = `現契約で設定される発行可能なMaxのチケットの上限を超えています。容量追加オプション購入など上限拡大をお願いします。（システム）`;
            break;
        case NotificationEventType.EXCEED_MAX_STORAGE:
            msg = `現契約で設定されるストレッジ容量の上限を超えています。容量追加オプション購入など上限拡大をお願いします。（システム）`;
            break;
        case NotificationEventType.EXCEED_MAX_GENERAL_USER_WHEN_CREATE_TICKET:
            msg = `現契約で設定されるジェネラルユーザー数の上限を超えています。ジェネラルユーザー追加オプション購入など上限拡大をお願いします。（システム）`;
            break;
        case NotificationEventType.KNOWLEDGE_CHAT_MESSAGE_NEW:
            if(sourceInfo.contentType === 'ATTACHMENT_FILE'){
                let nameOfFile = sourceInfo?.fileName?.toLowerCase()
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketTitle}」のスレッドでファイルを投稿しました (${sourceInfo.affiliationProjectName})`;
            // images
            let isImage = /\.(jpe?g|tiff?|png|webp|bmp)$/i.test(nameOfFile);
            if (isImage) {
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketTitle}」のスレッドで写真を投稿しました。(${sourceInfo.affiliationProjectName})`;
                break;
            }

            // gif
            let isGif = /\.(gif|GIF)$/i.test(nameOfFile);
            if (isGif) {
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketTitle}」のスレッドで動画を投稿しました。(${sourceInfo.affiliationProjectName})`;
                break;
            }

            // music
            let isMusic = /\.(mp3|MP3|mpeg|MPEG|m3u|M3U)$/i.test(nameOfFile);
            if (isMusic) {
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketTitle}」のスレッドで音楽を投稿しました。(${sourceInfo.affiliationProjectName})`;
                break;
            }

            // pdf
            let isPdf = /\.(pdf|PDF)$/i.test(nameOfFile);
            if (isPdf) {
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketTitle}」のスレッドでPDFを投稿しました。(${sourceInfo.affiliationProjectName})`;
                break;
            }

            let isVideoChatKnowledge= /\.(mp4|avi|mov|wmv|flv)$/i.test(nameOfFile)
            if (isVideoChatKnowledge) {
                msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketTitle}」のスレッドで動画を投稿しました。(${sourceInfo.affiliationProjectName})`;
                break;
            }

            msg = `${sourceInfo.creatorName}さんが「${sourceInfo.ticketTitle}」のスレッドでファイルを投稿しました。(${sourceInfo.affiliationProjectName})`;

            }else{
                msg = `${sourceInfo.creatorName}さんから「${
                    sourceInfo.ticketTitle
                }」にメッセージがありました。
                （${
                    Utils.isEmptyString(sourceInfo.affiliationProjectName)
                        ? ''
                        : sourceInfo.affiliationProjectName
                }）`;
                break;
            }
            break;
        case NotificationEventType.MENTION_IN_CHAT_KNOWLEDGE:
        msg = `${sourceInfo.creatorName}さんが「${
            sourceInfo.ticketTitle
        }」であなたにメンションしました。（${
            Utils.isEmptyString(sourceInfo.affiliationProjectName)
                ? ''
                : sourceInfo.affiliationProjectName
        }）`;
            break;
        case NotificationEventType.NOTI_UPDATE_CONTRACT_CREDIT_CARD:
            let organizationNameCreditCard =  Utils.isEmptyString(sourceInfo.organizationName)
            ? ''
            : sourceInfo.organizationName
            msg = `${organizationNameCreditCard}は支払方法をクレジットカードに変更しました。`
            break;
        case NotificationEventType.NOTI_UPDATE_CONTRACT_BANK_TRANSFER:
            let organizationName =  Utils.isEmptyString(sourceInfo.organizationName)
            ? ''    
            : sourceInfo.organizationName
            msg = `${organizationName}は支払方法を振込に変更しました。`;
            break;
        case NotificationEventType.OVER_MAX_RESOURCES:
            let itemOverMax = Utils.isEmptyString(sourceInfo.itemOverMax)? ''
            : sourceInfo.itemOverMax
            msg = `${itemOverMax}の上限を超えています。追加オプション購入など上限拡大をお願いします。`;
            break;
        case NotificationEventType.NOTI_ORG_REGISTERED_TRIAL:
            let organizationRegisteredName =  Utils.isEmptyString(sourceInfo.organizationName)
            ? ''
            : sourceInfo.organizationName
            let organizationRegisteredDomain =  Utils.isEmptyString(sourceInfo.organizationDomain)
            ? ''
            : sourceInfo.organizationDomain
            let organizationRegisteredTime =  Utils.isEmptyString(sourceInfo.createdAt)
            ? ''
            : sourceInfo.createdAt
            msg = `<p>${organizationRegisteredName}(${organizationRegisteredDomain})はお試し契約を登録しました。</p><p>登録日時：${organizationRegisteredTime}</p>`;
            break; 
        case NotificationEventType.NOTI_ORG_STARTED_TRIAL:
            let organizationStartedTrialName =  Utils.isEmptyString(sourceInfo.organizationName)
            ? ''
            : sourceInfo.organizationName
            let organizationStartedTrialDomain =  Utils.isEmptyString(sourceInfo.organizationDomain)
            ? ''
            : sourceInfo.organizationDomain
            let organizationStartedTrialTime =  Utils.isEmptyString(sourceInfo.createdAt)
            ? ''
            : sourceInfo.createdAt
            msg = `<p>${organizationStartedTrialName}(${organizationStartedTrialDomain})はお試し契約を開始しました。</p><p>登録日時：${organizationStartedTrialTime}</p>`;
            break;  
        case NotificationEventType.NOTI_YOURS_CONTRACT_HAVE_BEEN_UPDATED:
            msg = `<p>契約変更が完了されました。ご確認ください。</p>`;
            break;  
        default:
            break;
    }
    return msg;
};

/**
 * Check notification user
 * @param {*} notification
 * @param {*} argsCommon
 * @returns isNotification
 */
const isNotificationUser = (notification, argsCommon) => {
    let eventType = notification.eventType;

    // check type msg
    let isUserChange = [
        NotificationEventType.ADMIN_ON,
        NotificationEventType.ADMIN_OFF,
        NotificationEventType.OWNER_ON,
        NotificationEventType.OWNER_OFF,
        NotificationEventType.GENERAL_ON,
        NotificationEventType.GENERAL_OFF,
        NotificationEventType.MEMBER_ON,
        NotificationEventType.MEMBER_OFF,
        NotificationEventType.PM_ON,
        NotificationEventType.PM_OFF,
        NotificationEventType.USER_TYPE_CHANGE
    ].includes(eventType);
    if (!isUserChange) {
        return false;
    }

    let userDetail = argsCommon.userDetail;

    // user notification
    return userDetail.id === notification.notificationRange;
};

const isNotificationUserMustLogout = (notification, argsCommon) => {
    let eventType = notification.eventType;
    let sourceInfo = JSON.parse(notification.sourceInfo);
    let userDetail = argsCommon.userDetail;
    if (userDetail.id !== notification.notificationRange) {
        return false;
    }
    // user origin setting change 
    let isUserSettingChange = [
        NotificationEventType.ADMIN_ON,
        NotificationEventType.ADMIN_OFF,
        NotificationEventType.OWNER_ON,
        NotificationEventType.OWNER_OFF,
        NotificationEventType.GENERAL_ON,
        NotificationEventType.GENERAL_OFF,
        NotificationEventType.USER_TYPE_CHANGE
    ].includes(eventType);
    if (isUserSettingChange) {
        return true;
    }

    // not in project => not force logout
    const projectId = localStorageUtil.getSelectedProjectId();
    
   
    // check type msg
    let isUserProjectChange = [
        NotificationEventType.PM_ON,
        NotificationEventType.PM_OFF,
        // NotificationEventType.MEMBER_ON,
        NotificationEventType.MEMBER_OFF,
    ].includes(eventType);
    if (sourceInfo?.projectId !== projectId) {
        return false;
    }
   
    if (isUserProjectChange) {
        return true;
    }

    return false;
};

/**
 * Check notification ticket
 * @param {*} notification
 * @param {*} argsCommon
 * @returns isNotification
 */

const isNotificationTicket = (notification, argsCommon) => {
    
    let eventType = notification.eventType;
    
    let isNoticeTicket = notification.objectType === 'Notice';
    let sourceInfo = Utils.convertJSONDataToObject(notification.sourceInfo);
    const prefixOfPublicRange = Utils.getPrefixOfId(sourceInfo.publicRange);
    // list project Id
    let projectListId = [];
    let projectList = argsCommon.projectList;
    
    if (!Utils.isEmptyArray(projectList)) {
        projectList?.forEach(project => {
            projectListId.push(project.id);
        });
    }

    // check type msg
    let isTicket = [
        NotificationEventType.TICKET_NEW,
        NotificationEventType.TICKET_UPDATE,
        NotificationEventType.TICKET_APPROVAL_REQUEST,
        NotificationEventType.TICKET_DEADLINE_REACHED,
        NotificationEventType.TICKET_APPROVAL_IN_WORKFLOW,
        NotificationEventType.TICKET_REJECT_IN_WORKFLOW,
        NotificationEventType.UPDATE_PIC
    ].includes(eventType);
    if (!isTicket) {
        return false;
    }
    
    const userDetail = argsCommon.userDetail;

    if (userDetail.id === sourceInfo.creatorId) {
        return false;
    }
    if (userDetail.id === sourceInfo.updatorId) {
        return false;
    }
    
    // Handle TICKET_NEW event for TELEPHONE ticket only
    // TELEPHONE tickets send notification directly to B2C user 
    if (eventType === NotificationEventType.TICKET_NEW && 
        notification.objectType === Constant.NOTIFICATION_OBJECT_TYPE.TELEPHONE) {
        // Check if notification is sent directly to this user
        if (notification.notificationRange === userDetail.id) {
            return true;
        }
        
        // Check if notification is sent to user's current project or any project user belongs to
        if (notification.notificationRange === argsCommon.projectDetail.id || 
            projectListId.includes(notification.notificationRange)) {
            return true;
        }
    }
    
    if (eventType === NotificationEventType.UPDATE_PIC || eventType === NotificationEventType.TICKET_UPDATE) {
        if (
            notification.notificationRange === userDetail.id 
        ){
            return true;
        }
        else if(notification.notificationRange === argsCommon.projectDetail.id || projectListId.includes(notification.notificationRange)){
            return true
            /* let projectListUserInfo =  projectList.filter(item => item.id === notification.notificationRange);
            let filterCreatedAtResult = false;
            projectListUserInfo?.forEach(projectUserInfo => {
                if (projectUserInfo.userAddAt && notification.createdAt) {
                    let filterResult = filterCreateAtTime(
                        notification.createdAt,
                        projectUserInfo.userAddAt
                    );
                    filterCreatedAtResult = filterResult ? true : filterCreatedAtResult;
                }
            });
            return filterCreatedAtResult */
        }

        // switch (notification.notificationRange) {
        //     case Constant.NOTICE_GROUP_CUSTOMER.ALL_GENERAL_PROJECT:
        //     case Constant.NOTICE_GROUP_CUSTOMER.ALL_CUSTOMER_PROJECT:
        //     case Constant.NOTICE_GROUP_CUSTOMER.ALL_GUEST_CUSTOMER_USER:
        //         if (
        //             notification.sourceInfo && JSON.parse(notification.sourceInfo) &&
        //             JSON.parse(notification.sourceInfo).projectTarget.includes(argsCommon.projectDetail.id)
        //         ) return true
        //         return false
            
        //     case Constant.NOTICE_GROUP_CUSTOMER.ALL_USER_IN_BASE_PROJECT:
        //         let sourceInfo = notification.sourceInfo ? JSON.parse(notification.sourceInfo) : null
        //         if (
        //             notification.affiliationOrganization === argsCommon.projectDetail.affiliationOrganization
        //         ) return true
        //         return false

        //     default:
        //         break;
            
        // }

        return false
    }
    

    if (isNoticeTicket) {
        if (notification.notificationRange === argsCommon.userDetail.id) {
            return true;
        } else if (
            notification.notificationRange === argsCommon.projectDetail.id ||
            projectListId.includes(notification.notificationRange)
        ) {
            /* let projectListUserInfo = projectList.filter(
                item => item.id === notification.notificationRange
            );
            let filterCreatedAtResult = false;
            projectListUserInfo?.forEach(projectUserInfo => {
                if (projectUserInfo.userAddAt && notification.createdAt) {
                    let filterResult = filterCreateAtTime(
                        notification.createdAt,
                        projectUserInfo.userAddAt
                    );
                    filterCreatedAtResult = filterResult ? true : filterCreatedAtResult;
                }
            });
            return filterCreatedAtResult; */
            return true
        }

        return false;
        
    }
    
    if (
        notification.notificationRange === argsCommon.userDetail.id &&
        argsCommon.userDetail.id === sourceInfo.proxiedUser &&
        notification.objectType === 'DELEGATE'
    ) {
        return true;
    }
    // ticket notification
    // check memeber of project
    
    let projectTarget = Utils.isEmptyArray(sourceInfo.projectTarget)
        ? []
        : Utils.convertJSONDataToObject(sourceInfo.projectTarget);

        
    if (notification.objectType === 'KNOWLEDGE') {

        
        if (
            prefixOfPublicRange === 'corp' ||
            sourceInfo.publicRange === Constant.KNOWLEDGE_PUBLIC_RANGE.ALL
        ) {
            projectTarget = projectTarget.concat([sourceInfo.projectOrigin]);
        }
        projectTarget = Utils.isEmptyString(sourceInfo.publicRange)
            ? projectTarget
            : projectTarget.concat([sourceInfo.publicRange]);
    }
    
    // Ticket external customer
    if (notification.objectType === Constant.NOTIFICATION_OBJECT_TYPE.REQUEST_EXTERNAL_CUSTOMER) {
        if (notification.notificationRange === argsCommon.userDetail.id) {
            return true;
        } else if (
            notification.notificationRange === argsCommon.projectDetail.id ||
            projectListId.includes(notification.notificationRange)
        ) {
            /* let projectListUserInfo = projectList.filter(
                item => item.id === notification.notificationRange
            );
            let filterCreatedAtResult = false;
            projectListUserInfo?.forEach(projectUserInfo => {
                if (projectUserInfo.userAddAt && notification.createdAt) {
                    let filterResult = filterCreateAtTime(
                        notification.createdAt,
                        projectUserInfo.userAddAt
                    );
                    filterCreatedAtResult = filterResult ? true : filterCreatedAtResult;
                }
            });
            return filterCreatedAtResult; */
            return true
        }

        return false;
    }

    let isMemberProject = false;
    
    
    
    for (let index in projectList) {
        isMemberProject = projectTarget.includes(projectList[index].id);
        if(isMemberProject){
            break;
        }
        
        // if (isMemberProject) {
        //     let filterResult = false;
        //     if (projectList[index]?.userAddAt) {
        //         filterResult = filterCreateAtTime(
        //             notification.createdAt,
        //             projectList[index]?.userAddAt
        //         );
        //     }
        //     if (filterResult) break;
        //     isMemberProject = false
        // }
    }
    
    return isMemberProject;
};

/**
 * Check notification chat
 * @param {*} notification
 * @param {*} argsCommon
 * @returns isNotification
 */
const isNotificationChat = (notification, argsCommon) => {
    let eventType = notification.eventType;

    // check type msg
    let isMsgChat = [
        NotificationEventType.MESSAGE_NEW,
        NotificationEventType.MESSAGE_UPDATE,
        NotificationEventType.MESSAGE_STAMP_NEW,
        NotificationEventType.MESSAGE_ATTACHMENT_NEW,
        NotificationEventType.MESSAGE_REACTION,
        NotificationEventType.MESSAGE_MENTION_TO,
        NotificationEventType.KNOWLEDGE_CHAT_MESSAGE_NEW,
        NotificationEventType.MENTION_IN_CHAT_KNOWLEDGE
    ].includes(eventType);
    if (!isMsgChat) {
        return false;
    }

    if(eventType === NotificationEventType.KNOWLEDGE_CHAT_MESSAGE_NEW){
        return true
    }

    if(eventType === NotificationEventType.MENTION_IN_CHAT_KNOWLEDGE){
        return true
    }

    let userDetail = argsCommon.userDetail;
    let projectList = argsCommon.projectList;
    let exceptUserList = [];

    //Notification to mention user with event MESSAGE_MENTION_TO

    let sourceInfo = JSON.parse(notification.sourceInfo);
    if (sourceInfo.exceptUserList) {
        exceptUserList = Utils.convertJSONDataToObject(sourceInfo.exceptUserList);
    }
    if (exceptUserList.includes(userDetail.id)) {
        return false;
    }
    const prefixOfNotificationRange = Utils.getPrefixOfId(notification.notificationRange);
    let isMemberProject = false;
    if (prefixOfNotificationRange === 'user') {
        isMemberProject = userDetail.id === notification.notificationRange;
    }
    if (prefixOfNotificationRange === 'project') {
        isMemberProject = projectList.filter(item => item.id === notification.notificationRange).length > 0
        /* let projectListUserInfo =  projectList.filter(item => item.id === notification.notificationRange);
        projectListUserInfo?.forEach((projectUserInfo) =>{
            if(projectUserInfo.createdAt && notification.createdAt){
                let filterResult = filterCreateAtTime(notification.createdAt,projectUserInfo.createdAt)
                isMemberProject = filterResult? true : isMemberProject
            }
        }) */
    }
    // check member of project

    return isMemberProject && userDetail.id !== sourceInfo.creatorId;
};

const isNotificationFromExceedMaxTicket = (notification, argsCommon) => {
    let eventType = notification.eventType;
    if(eventType === Constant.NOTIFICATION_EVENT_TYPE.EXCEED_MAX_TICKET) {
        let userDetail = argsCommon.userDetail;
        return userDetail.id === notification.notificationRange;
    }

    return false;
}
const isNotificationFromExceedMaxGeneralWhenCreateTicket = (notification, argsCommon) => {
    let eventType = notification.eventType;
    if(eventType === Constant.NOTIFICATION_EVENT_TYPE.EXCEED_MAX_GENERAL_USER_WHEN_CREATE_TICKET) {
        let userDetail = argsCommon.userDetail;
        return userDetail.id === notification.notificationRange;
    }

    return false;
}

const isNotificationUpdatedContractOrgRoot = (notification, argsCommon) => {
    let eventType = notification.eventType;
    if(eventType === Constant.NOTIFICATION_EVENT_TYPE.NOTI_YOURS_CONTRACT_HAVE_BEEN_UPDATED) {
        let userDetail = argsCommon.userDetail;
        return userDetail.id === notification.notificationRange;
    }

    return false;
}

const isNotificationOverMaxResources = (notification, argsCommon) => {
    let eventType = notification.eventType;
    if(eventType === Constant.NOTIFICATION_EVENT_TYPE.OVER_MAX_RESOURCES) {
        let userDetail = argsCommon.userDetail;
        return userDetail.id === notification.notificationRange;
    }

    return false;
}

const isNotificationOrgRegister = (notification, argsCommon) => {
    let eventType = notification.eventType;
    if (
        [
            Constant.NOTIFICATION_EVENT_TYPE.NOTI_ORG_REGISTERED_TRIAL,
            Constant.NOTIFICATION_EVENT_TYPE.NOTI_ORG_STARTED_TRIAL
        ].includes(eventType)
    ) {
        if (!argsCommon?.userDetail || !argsCommon?.corporationDetail) return false;
        let userSettingValue = Utils.convertJSONDataToObject(argsCommon?.userDetail?.userSetting);
        return (
            (userSettingValue?.adminMode === Constant.ADMIN_MODE.ON &&
                Utils.isAdminUser(argsCommon?.userDetail) &&
                argsCommon.corporationDetail?.rootFlag)
        );
    }

    return false;
};

const isNotificationContract = (notification, argsCommon) => {
    let eventType = notification.eventType;
    if (
        [
            Constant.NOTIFICATION_EVENT_TYPE.NOTI_UPDATE_CONTRACT_BANK_TRANSFER,
            Constant.NOTIFICATION_EVENT_TYPE.NOTI_UPDATE_CONTRACT_CREDIT_CARD
        ].includes(eventType)
    ) {
        let userDetail = argsCommon.userDetail;
        return userDetail.id === notification.notificationRange;
    }

    return false;
};

const isReceiveNotification = (notification, argsCommon) => {
    let userDetail = argsCommon.userDetail;
    let settingNotification = userDetail.settingNotification;
    return true;
    // if settingNotification empty then return true
    /* if (Utils.isEmptyObject(settingNotification)) {
        return true;
    }

    try {
        settingNotification = JSON.parse(settingNotification);
    } catch (err) {
        return true;
    }

    let eventType = notification.eventType;
    // chat
    let isMsgChat = [
        NotificationEventType.MESSAGE_NEW,
        NotificationEventType.MESSAGE_UPDATE,
        NotificationEventType.MESSAGE_STAMP_NEW,
        NotificationEventType.MESSAGE_ATTACHMENT_NEW,
        NotificationEventType.MESSAGE_REACTION,
        NotificationEventType.MESSAGE_MENTION_TO
    ].includes(eventType);

    if (isMsgChat) {
        let isSDeskNotificationChatMsg = settingNotification.chatMsg.isSdeskNotification;
        return Utils.isEmpty(isSDeskNotificationChatMsg) ? true : isSDeskNotificationChatMsg;
    }

    // user change
    let isUserChange = [
        NotificationEventType.ADMIN_ON,
        NotificationEventType.ADMIN_OFF,
        NotificationEventType.OWNER_ON,
        NotificationEventType.OWNER_OFF,
        NotificationEventType.GENERAL_ON,
        NotificationEventType.GENERAL_OFF,
        NotificationEventType.MEMBER_ON,
        NotificationEventType.MEMBER_OFF,
        NotificationEventType.PM_ON,
        NotificationEventType.PM_OFF,
        NotificationEventType.USER_TYPE_CHANGE
    ].includes(eventType);
    if (isUserChange) {
        let isSDeskNotificationUserChange = settingNotification.userChange.isSdeskNotification;
        return Utils.isEmpty(isSDeskNotificationUserChange) ? true : isSDeskNotificationUserChange;
    }

    // ticket
    let isTicket = [
        NotificationEventType.TICKET_NEW,
        NotificationEventType.TICKET_UPDATE,
        NotificationEventType.TICKET_APPROVAL_REQUEST,
        NotificationEventType.TICKET_DEADLINE_REACHED,
        NotificationEventType.TICKET_APPROVAL_IN_WORKFLOW,
        NotificationEventType.TICKET_REJECT_IN_WORKFLOW
    ].includes(eventType);
    if (isTicket) {
        let isSDeskNotificationTicket = settingNotification.ticket.isSdeskNotification;
        return Utils.isEmpty(isSDeskNotificationTicket) ? true : isSDeskNotificationTicket;
    } */
};

/**
 * Update notification list in state
 * @param {*} notification
 * @param {*} argsCommon
 */
const updateNotificationListState = (notification, argsCommon) => {
    
    // check setting receive notification
    let isReceive = isReceiveNotification(notification, argsCommon);
    
    if (!isReceive) {
        return;
    }

    // user notification
    let isNotificationFromUser = isNotificationUser(notification, argsCommon);

    // ticket notification
    let isNotificationFromTicket = isNotificationTicket(notification, argsCommon);
    

    // chat notification
    let isNotificationFromChat = isNotificationChat(notification, argsCommon);

    // exceed setting max ticket notification
    let isNotificationExceedMaxTicket = isNotificationFromExceedMaxTicket(notification, argsCommon);

    // exceed setting max general when create ticket notification
    let isNotificationExceedMaxGeneralWhenCreateTicket = isNotificationFromExceedMaxGeneralWhenCreateTicket(notification, argsCommon);

    let isNotificationFromContract = isNotificationContract(notification, argsCommon);

    let isNotificationFromOverMaxResources = isNotificationOverMaxResources(notification, argsCommon);
    let isNotificationFromOrgRegister = isNotificationOrgRegister(notification, argsCommon);
    let isNotificationUpdatedContractOrg = isNotificationUpdatedContractOrgRoot(notification, argsCommon);

    let isNotification =
        isNotificationFromUser ||
        isNotificationFromTicket ||
        isNotificationFromChat ||
        isNotificationExceedMaxTicket ||
        isNotificationExceedMaxGeneralWhenCreateTicket ||
        isNotificationFromContract ||
        isNotificationFromOverMaxResources ||
        isNotificationFromOrgRegister ||
        isNotificationUpdatedContractOrg;

    if (isNotification) {
        // update post msg
        // let notificationUnReadListState = cloneDeep(argsCommon.notificationUnReadListState);
        let notificationUnReadListState = cloneDeep(getRecoil(notificationUnReadListAtom));

        // build msg
        notification.notificationMsg = getNotificationMsg(notification);
        notificationUnReadListState = [notification].concat(notificationUnReadListState);
        argsCommon.setNotificationUnReadListState(notificationUnReadListState);

        // update all msg
        // let notificationAllListState = cloneDeep(argsCommon.notificationAllListState);
        let notificationAllListState = cloneDeep(getRecoil(notificationListAtom));
        notificationAllListState = [notification].concat(notificationAllListState);


        argsCommon.setNotificationAllListState(notificationAllListState);

        if (isNotificationFromUser && isNotificationUserMustLogout(notification, argsCommon)) {
            signOut();
        }
    }
};

/**
 * Unsubscribe all with: event delete, update chat post
 */
export const unsubscribeEventNotification = () => {
    let isUnsubscribeEventNotification = false;
    if (Utils.isEmptyArray(subscriptionNotificationList)) {
        return isUnsubscribeEventNotification;
    }

    // unsubscription all notification
    subscriptionNotificationList.forEach(sub => {
        if (sub.subscription?._state !== 'closed') {
            sub.subscription?.unsubscribe();
            isUnsubscribeEventNotification = true;
        } 
    });
    subscriptionNotificationList = [];
    return isUnsubscribeEventNotification;
};

/**
 * Listen subscription event create notification
 * @param {*} API
 * @param {*} allState
 */
export const onSubscriptionEventCreateNotification = (API, allState) => {
    // check empty and exists of list
    // if subscriptionNotificationList exists then break;
    
    if (!Utils.isEmptyArray(subscriptionNotificationList)) {
        return;
    }
    let listNotificationRangeId = [allState?.userDetail?.id,allState?.corporationDetail?.id];
    allState?.projectList?.forEach(project => {
        listNotificationRangeId.push(project.id)
    });
    // unsub
    
    const listSubscription = multiConnectSubscription(listNotificationRangeId,allState);
    

    // push subscription to list
    subscriptionNotificationList.push(...listSubscription)
};

const renderFilterNotification = (listNotificationRange) => {
    if(listNotificationRange.length === 0) return {
        "notificationRange" : {
            "in": []
        }
    }
    let notificationRangeFilter = [];
    let subListNotificationRange = []
    for(let i = 0; i < listNotificationRange.length; i++ ){
        if(subListNotificationRange.length === 5){
            notificationRangeFilter.push(
                {
                    "notificationRange" : {
                        "in": subListNotificationRange
                    } 
                }
            )
            subListNotificationRange = [];
            subListNotificationRange.push(listNotificationRange[i]);
            continue;
        }else if(i === listNotificationRange.length - 1){
            subListNotificationRange.push(listNotificationRange[i]);
            notificationRangeFilter.push(
                {
                    "notificationRange" : {
                        "in": subListNotificationRange
                    } 
                }
            )
            subListNotificationRange = [];
            continue;
        }
        subListNotificationRange.push(listNotificationRange[i]);

    }
    return notificationRangeFilter;

}

const connectNotificationSubscription = (listNotificationRangeId,allState,index) => {
    let filterOr = {
        or: renderFilterNotification(listNotificationRangeId)
    };
    
    let filterString = JSON.stringify(filterOr);
    let subscription = APIAmplify.graphql({query: onGetNotificationByFilter,
        variables: { filter: filterString }
    }).subscribe({
        next: resData => {
            let msgRes = resData.value.data.onGetNotificationByFilter;

            if(msgRes?.eventType === Constant.NOTIFICATION_EVENT_TYPE.DELETE_PROJECT ){
                allState.setProjectDeletedSubscription({id: msgRes?.affiliationProject, active: Constant.ACTIVE_FLAG.DELETED});
            }else{
                // update notification list
                updateNotificationListState(msgRes, allState);
            }
            
        },
        
        error: err => {
            console.log('connectNotificationSubscription', err)
            // unsubscription event create
            let isUnsubscribeEventNotification = unsubscribeEventNotification();

            // show alert disconnect
            // if isShowDialog equals true then break
            if (!allState.isShowReconnectDialog && isUnsubscribeEventNotification === true) {
                allState.setIsShowReconnectDialog(true);
            }
        }
    });

    return subscription;
}

const multiConnectSubscription = (listNotificationRangeId,allState) => {
    let listSubscription = [];
    let listNotificationRange = []
    for(let index=0 ; index < listNotificationRangeId?.length; index++){
        if(listNotificationRange.length === 10){
            const timeStamd = new Date().getTime()
            const subscription = connectNotificationSubscription(listNotificationRange,allState,timeStamd);
            listNotificationRange = [];
            listSubscription.push({subscription: subscription});
        }

        listNotificationRange.push(listNotificationRangeId[index]);

        if(index+1 === listNotificationRangeId?.length){
            const timeStamd = new Date().getTime()
            const subscription = connectNotificationSubscription(listNotificationRange,allState,timeStamd);
            listNotificationRange = [];
            listSubscription.push({subscription: subscription});
        }

    }

    return listSubscription
}

/**
 * Subscribe to onTicketCreated event for telephone tickets
 * @param {Object} allState - contains corporationDetail, projectInuseDetail, userDetail, projectList, addNewPanel
 */
export const subscribeTicketCreated = (allState) => {
    if (ticketCreatedSubscription) {
        return;
    }

    const corporationId = allState?.corporationDetail?.id;
    const projectInuseId = allState?.projectInuseDetail?.id;
    if (!corporationId || !projectInuseId) {
        return;
    }

    ticketCreatedSubscription = APIAmplify.graphql({
        query: onTicketCreated,
        variables: {
            ticketType: Constant.TICKET_TYPE.TELEPHONE,
            affiliationOrganization: corporationId,
            affiliationProject: projectInuseId || undefined
        }
    }).subscribe({
        next: resData => {
            const ticketData = resData?.value?.data?.onTicketCreated;
            if (!ticketData) return;

            handleTicketCreatedEvent(ticketData, allState);
        },
        error: err => {
            console.log('[subscribeTicketCreated] error:', err);
            unsubscribeTicketCreated();
        }
    });
};

/**
 * Unsubscribe from onTicketCreated event
 */
export const unsubscribeTicketCreated = () => {
    if (ticketCreatedSubscription) {
        ticketCreatedSubscription.unsubscribe();
        ticketCreatedSubscription = null;
    }
};

/**
 * Handle ticket created event from subscription
 * @param {Object} ticketData - ticket data from subscription
 * @param {Object} allState - component state
 */
const handleTicketCreatedEvent = async (ticketData, allState) => {
    const userId = allState?.userDetail?.id;
    const metaData = Utils.convertJSONDataToObject(ticketData.metaData);

    if (!metaData) return;

    // Skip if current user is the creator and already handled via custom parameters (inbound)
    if (ticketData.creator === userId) return;

    // Check if this ticket matches current outbound call
    const outboundCall = getRecoil(outboundCallAtom);
    const activeCall = getRecoil(activeCallAtom);

    const ticketCallSid = metaData?.twilioCallSid;
    const currentCallSid = outboundCall?.callSid || activeCall?.parameters?.CallSid;

    if (!ticketCallSid || !currentCallSid) return;
    if (ticketCallSid !== currentCallSid) return;

    // Match found — open ticket panel
    const ticketInfo = {
        ticketId: ticketData.id,
        chatThreadId: ticketData.chatThreadWithCustomer,
    };

    const projectInuseDetail = allState?.projectInuseDetail;
    const projectList = allState?.projectList;
    const addNewPanel = allState?.addNewPanel;

    if (addNewPanel) {
        await openTelephoneTicketPanel(ticketInfo, projectInuseDetail, projectList, addNewPanel);
    }
};
